export class GetWeeekTaskModel {
  /**
   * * Номер задачи на weeek
   */
  WeeekTaskId?: number;
  /**
   * * Адрес ссылки к задаче
   */
  WeeekTaskUrl?: string;
  /**
   * * Номер проекта
   */
  ProjectId!: number;
  /**
   * * Номер очереди
   */
  QueueTaskId!: string;

  constructor(obj?: Partial<GetWeeekTaskModel>) {
    Object.assign(this, obj);
  }
}
